module.exports = __webpack_public_path__ + "ptc_nakagawa_N2.4707ac42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_N2.jpg
// module id = aMnK
// module chunks = 0